import React from "react";

const USPAndGPPFooter = ({ consent, updateUSPAndGPP }) => {
  const handleUSPChange = (e) => {
    const stayOptedIn = e.target.checked; // When checked, user allows data use (NOT opted out)
    const uspString = stayOptedIn ? "1YNN" : "1YYN";
    updateUSPAndGPP({ ...consent, uspConsent: stayOptedIn, uspString });
  };

  const handleGPPChange = (e) => {
    const stayOptedIn = e.target.checked; // When checked, user allows data use (NOT opted out)
    const gppString = stayOptedIn ? "GPP0" : "GPP1";
    updateUSPAndGPP({ ...consent, gppConsent: stayOptedIn, gppString });
  };

  return (
    <div className="flex pt-2 pr-4 pb-4 pl-0">
      <div className="flex flex-col gap-4 items-start">
        <label className="flex items-center gap-2 m-0 text-sm">
        <input 
            type="checkbox" 
            checked={consent.uspConsent}
            onChange={handleUSPChange}
            className="h-4 w-4 border border-gray-300"
          style={{ backgroundColor: 'white', accentColor: 'white' }}
          />
          Opted In For CCPA
          
        </label>
        <label className="flex items-center gap-2 m-0 text-sm">
        <input 
            type="checkbox" 
            checked={consent.gppConsent}
            onChange={handleGPPChange}
            className="h-4 w-4 border border-gray-300"
            style={{ backgroundColor: 'white', accentColor: 'white' }}
          />
          Opted In For GPP
          
        </label>
      </div>
    </div>
  );
};

export default USPAndGPPFooter;
